import client from "../libs/HttpClient";

class QuoteServices {
  static quoteList(request) {
    
    const page_no = request.queryKey[1];
    return client.get(`/quote?page=${page_no}`, request);
  }

  static viewQuote(params) {
    return client.get(`quoteReview`, { params });
  }
}

export { QuoteServices };
